import { render, staticRenderFns } from "./SignUpStudy.vue?vue&type=template&id=0cb67a61&lang=html"
import script from "./SignUpStudy.vue?vue&type=script&lang=js"
export * from "./SignUpStudy.vue?vue&type=script&lang=js"
import style0 from "./SignUpStudy.vue?vue&type=style&index=0&id=0cb67a61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports